import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';

import { MarketingActivityList } from './MarketActivites';
import { ReserveActivities } from './ReserveActivities';
import { ReserveActivityConfig } from './ReserveActivityConfig';
import { ReserveAddRobots } from './ReserveAddRobots';
import { ReserveActivityRule } from './ReserveRule';
import { ConfigActivity } from './SetActivity';

export const Marketing = (props: RouteComponentProps) => (
  <Switch>
    <Route path={`${props.match.path}/activities`} component={MarketingActivityList} />;
    <Route path={`${props.match.path}/activity/setting/:name/:id`} component={ConfigActivity} />;
    <Route path={`${props.match.path}/:id/rule`} component={ReserveActivityRule} />
    <Route path={`${props.match.path}/:id/config`} component={ReserveActivityConfig} />
    <Route path={`${props.match.path}/:id/robots`} component={ReserveAddRobots} />
    <Route path={props.match.path} component={ReserveActivities} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/screens/marketing/Marketing.tsx